import React from 'react';

import { GOOGLE_MAP_CUSTOM_STYLE } from '@rover/constants/src/search/googleMap.constants';
import SearchMap from '@rover/react-lib/src/pages/search/SearchPage/components/SearchMap/SearchMap';
import { SearchResult } from '@rover/types';

type OverrideableProps =
  | 'onMapMoved'
  | 'searchInitiatedByMap'
  | 'onMarkerClick'
  | 'onZoomChanged'
  | 'showStaticMap'
  | 'showDynamicMap'
  | 'mapStyle'
  | 'rolloutSignStaticMap'
  | 'options';
type Props = Omit<React.ComponentProps<typeof SearchMap>, OverrideableProps> & {
  mapMode: 'static' | 'dynamic';
  searchResultsRefs: HTMLDivElement[];
  hoveringResultIndex: number | null;
};

const SearchResultsMap: React.FC<Props> = ({
  mapMode,
  searchResultsRefs,
  searchResults,
  ...rest
}) => {
  // Changing the ranks to null keeps the map from displaying the rank in the markers.
  const searchResultsWithNullRank = searchResults.map((result: SearchResult) => ({
    ...result,
    rank: null,
  }));

  return (
    <SearchMap
      onMapMoved={() => {}}
      searchInitiatedByMap={false}
      onMarkerClick={(index) => {
        searchResultsRefs?.[index]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }}
      onZoomChanged={() => {}}
      showStaticMap={mapMode === 'static'}
      showDynamicMap={mapMode === 'dynamic'}
      mapStyle={GOOGLE_MAP_CUSTOM_STYLE}
      rolloutSignStaticMap
      options={{ draggable: false, zoomControl: false }}
      searchResults={searchResultsWithNullRank}
      {...rest}
    />
  );
};

export default SearchResultsMap;
